import React from 'react';
import config from '../../constant/config';
import CreateCourse from '../common/CreateCourse';  
import checkStatus from '../common/checkStatus';


class EditCourse extends React.Component {
constructor(props) {
  super(props);
  this.state = {
    course: null,
    modules: [],
    hubId: this.props.location && this.props.location.state ? this.props.location.state.hubId : null,
  };
}
async getModules(hubid) {
    try {
      const res = await fetch(`${config.apiURL}/hub/${hubid}/modules`, {
        credentials: 'include',
        method: 'GET',
        headers: { 'content-type': 'application/json' },
      });
      if (res.status === 200) {
        const data = await res.json();
        console.log(data.modules)
        this.setState({ modules: data.modules});
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getCourse() {
        const { courseId } = this.props.match.params;
try {const res = await fetch(`${config.apiURL}/course/${courseId}`, {
     credentials: 'include',
    method: 'GET',
    headers: { 'content-type': 'application/json' }, });
if (res.status === 200) {
const course = await res.json();
console.log(course);
this.setState({ course });
}}
catch (err) {
console.log(err);
}
  } 

 async componentWillMount() {
    if(!this.props.user){
      this.props.history.push('/');
    }
    else{

       await  this.getModules(this.state.hubId); 
       await this.getCourse();

    }
    }

  render(){
    return(
        <div>
           <CreateCourse hubId={this.state.hubId} modules={this.state.modules} approved={true} user={this.props.user} history={this.props.history} edit={true} course={this.state.course}/>
        </div>
    )
  }
}

export default checkStatus(EditCourse);